const Generic = () => {
    return (
        <div className="w-full p-6 rounded-full bg-gray-150 text-center">
            <div>Sorry!</div>
            <p className="mt-3">
                Something went wrong and we couldn't load this page. Please try again or contact
                support if this error persists.
            </p>
        </div>
    );
};

export default Generic;
